export default "__VITE_ASSET__Bm9o30Jl__"